import Crud from '../views/TeamType/Crud'
import Entity from '../views/TeamType/Add'

let routes = {
    path: '/team_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/team_types/add',
            name: 'NewTeamType',
            component: Entity,
            meta: {
                pageTitle: 'teamType.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'teamType.form.titleNew',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/team_types/edit/:id?',
            name: 'EditTeamType',
            component: Entity,
            meta: {
                pageTitle: 'teamType.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'teamType.form.titleEdit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/team_types',
            name: 'list-team-types',
            component: Crud,
            meta: {
                pageTitle: 'teamType.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'teamType.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};

export default routes
